import { createFileRoute } from '@tanstack/react-router';

import { EditUserForm } from '@/features/users/EditUserForm';

function EditUserRoute() {
  const { userId } = Route.useParams();
  return <EditUserForm userId={userId} />;
}

export const Route = createFileRoute('/admin/_app/users/$userId/edit')({
  component: EditUserRoute,
});
